export default __webpack_public_path__ + "static/media/P-green.daf37290.svg";